module.exports = {"title":"Register Reply","replyStatus":"Reply Status","answered":"Answered","checking":"In Review","contentPlaceholder":"Enter content.","confirmMessage":"Registering a reply will send<br>a notification to the inquirer.<br>Do you want to register it?","registeredAlert":"Your reply has been registered.","typeService":"Service","typeEvent":"Event","typeUpdate":"Update"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/cs105.json
// module id = 2iz6
// module chunks = 2